import React, {Component} from 'react'
import ReactTable from 'react-table'
import {debounce} from "lodash";
import PropTypes from 'prop-types'

export default class SystemSettingsTable extends Component{

    render(){

        const {data, loading, onClick} = this.props

        return (
            <ReactTable
                data={data}
                loading={loading}
                style={{display: 'flex', flex: 1, fontSize: '14px'}}
                columns={[
                    {
                        Header: "ID",
                        id: 'id',
                        accessor: 'id',
                        width: 100,
                        filterable: false
                    },
                    {
                        Header: "Description",
                        id: 'description',
                        accessor: 'description'
                    },
                    {
                        Header: "Setting Value",
                        id: 'setting_value',
                        accessor: 'setting_value'
                    },


                ]}
                className="-striped -highlight"
                filterable
                showPagination={true}
                getTrProps={(state, rowInfo) => {
                    return {
                        onClick: (e) => {
                            console.log(rowInfo)
                            if(onClick) onClick(rowInfo.original.id)
                            //Router.push({pathname: '/projects/edit', query: { project_id: rowInfo.original.project_id }})
                        }
                    }
                }}
            />
        )

    }

}

SystemSettingsTable.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func
}